import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

const AdminSettings = () => {
  const [f, setF] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/settings').then(({ data }) => { setF(data || {}); setLoading(false); });
  }, []);

  const save = async () => {
    try {
      await api.put('/admin/settings', {
        contact_email: f.contact_email || '',
        contact_phone: f.contact_phone || '',
        footer_text: f.footer_text || '',
        consultation_fee: Number(f.consultation_fee || 1000),
        social: f.social || {},
        seo_defaults: f.seo_defaults || {},
        ga_id: f.ga_id || '',
        meta_pixel_id: f.meta_pixel_id || '',
        gtm_id: f.gtm_id || '',
        hero_headline: f.hero_headline || '',
        hero_subhead: f.hero_subhead || '',
        whatsapp_number: f.whatsapp_number || '',
      });
      toast.success('Settings saved');
    } catch { toast.error('Save failed'); }
  };

  const bind = (key) => ({ value: f[key] || '', onChange: (e) => setF({ ...f, [key]: e.target.value }) });
  const bindSocial = (key) => ({ value: (f.social || {})[key] || '', onChange: (e) => setF({ ...f, social: { ...(f.social || {}), [key]: e.target.value } }) });
  const bindSEO = (key) => ({ value: (f.seo_defaults || {})[key] || '', onChange: (e) => setF({ ...f, seo_defaults: { ...(f.seo_defaults || {}), [key]: e.target.value } }) });
  const InputCls = 'w-full border border-sans_line bg-white px-3 py-2.5 text-sm text-sans_ink focus:outline-none focus:border-sans_ink';
  const TAcls = InputCls;

  if (loading) return <div className="text-sans_mute">Loading…</div>;

  return (
    <div>
      <h1 className="font-serif text-4xl text-sans_ink tracking-tight">Site Settings</h1>
      <p className="text-sans_mute mt-2">Edit contact, social, hero, SEO, tracking scripts.</p>

      <div className="mt-10 grid md:grid-cols-2 gap-8 max-w-4xl">
        <div>
          <div className="sans-label mb-4">Contact</div>
          <div className="space-y-4">
            <div><label className="sans-label block mb-1">Contact email</label><input {...bind('contact_email')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Contact phone</label><input {...bind('contact_phone')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">WhatsApp number (with country code, no +)</label><input {...bind('whatsapp_number')} placeholder="e.g. 919876543210" className={InputCls} data-testid="settings-whatsapp" /></div>
            <div><label className="sans-label block mb-1">Consultation fee (₹)</label><input type="number" {...bind('consultation_fee')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Footer text</label><textarea rows={3} {...bind('footer_text')} className={TAcls} /></div>
          </div>
        </div>

        <div>
          <div className="sans-label mb-4">Social</div>
          <div className="space-y-4">
            {['instagram', 'facebook', 'twitter', 'youtube', 'linkedin'].map((k) => (
              <div key={k}><label className="sans-label block mb-1 capitalize">{k}</label><input {...bindSocial(k)} placeholder={`https://${k}.com/…`} className={InputCls} /></div>
            ))}
          </div>
        </div>

        <div>
          <div className="sans-label mb-4">Homepage hero (fallback if not overridden)</div>
          <div className="space-y-4">
            <div><label className="sans-label block mb-1">Headline</label><input {...bind('hero_headline')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Subhead</label><textarea rows={3} {...bind('hero_subhead')} className={TAcls} /></div>
          </div>
        </div>

        <div>
          <div className="sans-label mb-4">SEO defaults</div>
          <div className="space-y-4">
            <div><label className="sans-label block mb-1">Default title</label><input {...bindSEO('title')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Default description</label><textarea rows={3} {...bindSEO('description')} className={TAcls} /></div>
            <div><label className="sans-label block mb-1">OG image URL</label><input {...bindSEO('og_image')} className={InputCls} /></div>
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="sans-label mb-4">Tracking / analytics</div>
          <div className="grid md:grid-cols-3 gap-4">
            <div><label className="sans-label block mb-1">GA measurement ID</label><input {...bind('ga_id')} placeholder="G-XXXXXXXXXX" className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Meta Pixel ID</label><input {...bind('meta_pixel_id')} className={InputCls} /></div>
            <div><label className="sans-label block mb-1">Google Tag Manager</label><input {...bind('gtm_id')} placeholder="GTM-XXXXXX" className={InputCls} /></div>
          </div>
          <div className="mt-2 text-xs text-sans_mute">Fields are stored — full tracking script injection can be enabled in Phase 3.</div>
        </div>
      </div>

      <div className="mt-10 max-w-4xl">
        <button onClick={save} className="sans-btn-primary" data-testid="settings-save">Save settings</button>
      </div>
    </div>
  );
};

export default AdminSettings;
